/* ../src/components/UserAddress.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text
} from "svelte/internal";

import store from "../store";

function create_else_block_1(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = "Connect your wallet to continue";
			attr(div, "class", "address-container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (21:0) {#if $store.userAddress}
function create_if_block(ctx) {
	let div5;
	let div0;
	let t0;
	let div4;
	let div3;
	let div1;
	let p0;
	let t2;
	let p1;
	let t3;
	let t4_value = /*$store*/ ctx[0].userAddress.slice(0, 7) + "..." + /*$store*/ ctx[0].userAddress.slice(-7) + "";
	let t4;
	let t5;
	let div2;
	let p2;
	let t7;
	let mounted;
	let dispose;
	let if_block0 = /*$store*/ ctx[0].userAddress && create_if_block_3(ctx);

	function select_block_type_1(ctx, dirty) {
		if (/*$store*/ ctx[0].userBalance !== undefined) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type_1(ctx, -1);
	let if_block1 = current_block_type(ctx);

	return {
		c() {
			div5 = element("div");
			div0 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			div4 = element("div");
			div3 = element("div");
			div1 = element("div");
			p0 = element("p");
			p0.textContent = "Status: Connected";
			t2 = space();
			p1 = element("p");
			t3 = text("Address: ");
			t4 = text(t4_value);
			t5 = space();
			div2 = element("div");
			p2 = element("p");
			p2.textContent = "Balance";
			t7 = space();
			if_block1.c();
			attr(div0, "class", "img-container");
			attr(p1, "class", "subtitle svelte-34cof9");
			set_style(p1, "cursor", "pointer");
			set_style(div2, "text-align", "right");
			attr(div3, "class", "address-container__text svelte-34cof9");
			set_style(div4, "width", "100%");
			attr(div5, "class", "address-container");
		},
		m(target, anchor) {
			insert(target, div5, anchor);
			append(div5, div0);
			if (if_block0) if_block0.m(div0, null);
			append(div5, t0);
			append(div5, div4);
			append(div4, div3);
			append(div3, div1);
			append(div1, p0);
			append(div1, t2);
			append(div1, p1);
			append(p1, t3);
			append(p1, t4);
			append(div3, t5);
			append(div3, div2);
			append(div2, p2);
			append(div2, t7);
			if_block1.m(div2, null);

			if (!mounted) {
				dispose = listen(p1, "click", /*click_handler*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*$store*/ ctx[0].userAddress) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(div0, null);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*$store*/ 1 && t4_value !== (t4_value = /*$store*/ ctx[0].userAddress.slice(0, 7) + "..." + /*$store*/ ctx[0].userAddress.slice(-7) + "")) set_data(t4, t4_value);

			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if_block1.d(1);
				if_block1 = current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div2, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div5);
			if (if_block0) if_block0.d();
			if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

// (24:6) {#if $store.userAddress}
function create_if_block_3(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = `https://services.tzkt.io/v1/avatars/${/*$store*/ ctx[0].userAddress}`)) attr(img, "src", img_src_value);
			attr(img, "alt", "avatar");
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$store*/ 1 && img.src !== (img_src_value = `https://services.tzkt.io/v1/avatars/${/*$store*/ ctx[0].userAddress}`)) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (48:10) {:else}
function create_else_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "---";
			attr(p, "class", "subtitle svelte-34cof9");
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (43:10) {#if $store.userBalance !== undefined}
function create_if_block_1(ctx) {
	let p;
	let t0_value = /*$store*/ ctx[0].userBalance.toLocaleString("en-US") + "";
	let t0;
	let t1;
	let if_block = /*$store*/ ctx[0].userBalance !== "Not available" && create_if_block_2(ctx);

	return {
		c() {
			p = element("p");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			attr(p, "class", "subtitle svelte-34cof9");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, t1);
			if (if_block) if_block.m(p, null);
		},
		p(ctx, dirty) {
			if (dirty & /*$store*/ 1 && t0_value !== (t0_value = /*$store*/ ctx[0].userBalance.toLocaleString("en-US") + "")) set_data(t0, t0_value);

			if (/*$store*/ ctx[0].userBalance !== "Not available") {
				if (if_block) {
					
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(p, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(p);
			if (if_block) if_block.d();
		}
	};
}

// (46:14) {#if $store.userBalance !== 'Not available'}
function create_if_block_2(ctx) {
	let t;

	return {
		c() {
			t = text("tokens");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*$store*/ ctx[0].userAddress) return create_if_block;
		return create_else_block_1;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $store;
	component_subscribe($$self, store, $$value => $$invalidate(0, $store = $$value));
	const click_handler = () => store.updateRecipientAddress($store.userAddress);
	return [$store, click_handler];
}

class UserAddress extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default UserAddress;